import React from "react";
import PropTypes from "prop-types";

import ApplicationFeeResource from 'resources/organization/ApplicationFeeResource';

import NumberTextField from "components/NumberTextfield";

import { labels } from "utils/pricingsConsts";
import { convertPriceFromCents, convertPriceToCents } from 'utils/rewards';

import { InputAdornment } from "@mui/material";
import { useParams } from "react-router-dom";
import { useController } from "@rest-hooks/react";
import { useError } from "utils/useErrorController";

const PriceField = ({errors, frequency, price, isDisabled, onPriceChange, onChange, icon, showApplicationFee, onEdit}) => {

  const {loading, setLoading} = useError(false);

  const {fetch} = useController();
  const params  = useParams();
  const organizationId = parseInt(params.organizationId);

  const label =
      errors[ frequency ] 
        ? frequency === 'lifetime' 
          ? labels["remove"]
          : labels["format"] 
        : labels[frequency];

  const handleBlur = async () => {
    if (!showApplicationFee) return;
    setLoading(true);

    const { application_fee } = await fetch(ApplicationFeeResource.list(), {organization_id: organizationId, price: convertPriceToCents(price)});
    onChange({target: {name: 'application_fee', value: convertPriceFromCents(application_fee)}});
    onEdit(false);
    setLoading(false);
  };

  const handleFocus = () => {
    // not present when PriceField is used to edit quarterly or yearly price of a pass
    if (onEdit) onEdit(true);
  };

  return (
    <NumberTextField 
      error={frequency !== 'lifetime' && errors[ frequency ]}
      name={frequency}
      label={label}
      color="warning"
      size="small"
      fullWidth
      value={price || ''}
      onChange={onPriceChange}
      onPaste={event => event.preventDefault()}
      disabled={isDisabled || loading}
      InputProps={{
        endAdornment: <InputAdornment position="end">{icon}</InputAdornment>,
      }}
      onBlur={handleBlur}
      onFocus={handleFocus}
    />
  );
};

PriceField.propTypes = {
  errors: PropTypes.object,
  frequency: PropTypes.string,
  price: PropTypes.string,
  label: PropTypes.string,
  isDisabled: PropTypes.bool,
  onPriceChange: PropTypes.func,
  onChange: PropTypes.func,
  icon: PropTypes.object,
  showApplicationFee: PropTypes.bool,
  onEdit: PropTypes.func
};

export default PriceField;